module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Beringen-8f480d25521b6e51a87cfc5847bbc021.png";